import {
  FREE,
  STARTER,
  TRIAL,
  MANAGER,
  PARTNER,
  STANDARD,
  PRO,
  ENTERPRISE,
} from '../const/plan'

/**
 * プランとアクセスリスト
 */
export const acl = {
  eqStarterPlan: (activate) => {
    if (activate == STARTER) return true
    return false
  },
  eqTrialPlan: (activate) => {
    if (activate == TRIAL) return true
    return false
  },
  eqManagerPlan: (activate) => {
    if (activate == MANAGER) return true
    return false
  },
  eqPartnerPlan: (activate) => {
    if (activate == PARTNER) return true
    return false
  },
  eqProPlan: (activate) => {
    if (activate == PRO) return true
    return false
  },
  eqEnterprisePlan: (activate) => {
    if (activate == ENTERPRISE) return true
    return false
  },
  gteStarterPlan: (activate) => {
    if (activate >= STARTER) return true
    return false
  },
  gteTrialPlan: (activate) => {
    if (activate >= TRIAL) return true
    return false
  },
  gteManagerPlan: (activate) => {
    if (activate >= MANAGER) return true
    return false
  },
  gtePartnerPlan: (activate) => {
    if (activate >= PARTNER) return true
    return false
  },
  gteStandardPlan: (activate) => {
    if (activate >= STANDARD) return true
    return false
  },
  gteStandardAndTrialPlan: (activate) => {
    if (activate == TRIAL) return true
    if (activate >= STANDARD) return true
    return false
  },
  gteManagerAndTrialPlan: (activate) => {
    if (activate == TRIAL) return true
    if (activate >= MANAGER) return true
    return false
  },
  gteProPlan: (activate) => {
    if (activate >= PRO) return true
    return false
  },
  lteFreePlan: (activate) => {
    if (activate <= FREE) return true
    return false
  },
  paidPlan: (activate) => {
    if (activate == STARTER) return true
    if (activate >= MANAGER) return true
    return false
  },
}

/**
 * 現在のプランが制御対象に対してアクセス権を有しているかを判定
 * @param activate client_list.activateの値
 * @param plan 権限
 * @return {boolean} true:許可、false:拒否
 */
export const can = (activate, plan) => {
  return acl[plan](activate)
}